module.exports = __webpack_public_path__ + "public/img/Pelayanan Pelanggan Untuk Customer Service.f0ce033a.png";